import Swiper from 'swiper/bundle';
import Helper from './helper';
import 'bootstrap';

import.meta.glob([
    '../img/**'
]);

import 'swiper/css/bundle';

class App {
    constructor() {
        this.cardsSliderMediaQuery = window.matchMedia('(max-width: 767.98px)');
        this.cardsSliderInstances = new Map();
        this.cardsSliderElements = [];

        this.init();
    }

    init() {
        this.initNavbarBackdrop();
        this.initStickyNavbar();
        this.initCardsSlider();
        this.partnerSlider();
        this.honeyForms();
        this.asyncForms();
        this.cookies();
        this.stepsScroller();
        this.scrollIntoView();
    }

    initCardsSlider() {
        this.cardsSliderElements = [...document.querySelectorAll('[data-cards-slider]')].map((element, index) => ({
            element,
            id: element.id || `cards-slider-${index + 1}`,
            originalMarkup: element.innerHTML
        }));

        if (!this.cardsSliderElements.length) {
            return;
        }

        this.toggleCardsSlider();

        const mediaQueryListener = () => this.toggleCardsSlider();

        if (typeof this.cardsSliderMediaQuery.addEventListener === 'function') {
            this.cardsSliderMediaQuery.addEventListener('change', mediaQueryListener);

            return;
        }

        this.cardsSliderMediaQuery.addListener(mediaQueryListener);
    }

    toggleCardsSlider() {
        this.cardsSliderElements.forEach((slider) => {
            if (this.cardsSliderMediaQuery.matches) {
                this.enableCardsSlider(slider);

                return;
            }

            this.disableCardsSlider(slider);
        });
    }

    enableCardsSlider(slider) {
        if (this.cardsSliderInstances.has(slider.element)) return;

        const source = document.createElement('div');
        source.innerHTML = slider.originalMarkup;

        const introBlocks = [...source.querySelectorAll('.cards__content')];
        const slideBlocks = [...source.querySelectorAll('.cards__item')];

        if (!introBlocks.length && !slideBlocks.length) return;

        slider.element.innerHTML = '';
        slider.element.id = slider.id;
        slider.element.classList.add('swiper', 'cards__list--swiper');

        if (introBlocks.length) {
            const intro = document.createElement('div');
            intro.className = 'cards__mobile-intro';

            introBlocks.forEach((block) => {
                intro.appendChild(block.cloneNode(true));
            });

            slider.element.appendChild(intro);
        }

        if (!slideBlocks.length) return;

        const wrapper = document.createElement('div');
        wrapper.className = 'swiper-wrapper';

        slideBlocks.forEach((block) => {
            const slide = document.createElement('div');
            slide.className = 'swiper-slide cards__slide';
            slide.appendChild(block.cloneNode(true));
            wrapper.appendChild(slide);
        });

        const pagination = document.createElement('div');
        pagination.className = 'swiper-pagination cards__pagination';

        slider.element.append(wrapper, pagination);

        const instance = new Swiper(slider.element, {
            slidesPerView: 1.1,
            spaceBetween: 15,
            slidesPerGroup: 1,
            grabCursor: true,
            pagination: {
                el: pagination,
                clickable: true
            },
            breakpoints: {
                576: {
                    slidesPerView: 1.35
                }
            }
        });

        this.cardsSliderInstances.set(slider.element, instance);
    }

    disableCardsSlider(slider) {
        const instance = this.cardsSliderInstances.get(slider.element);

        if (!instance) return;

        instance.destroy(true, true);
        this.cardsSliderInstances.delete(slider.element);

        slider.element.classList.remove('swiper', 'cards__list--swiper');
        slider.element.innerHTML = slider.originalMarkup;
    }

    initNavbarBackdrop() {
        const navbarEl = document.getElementById('main-navbar');
        const collapseEl = document.getElementById('main-navbar-collapse');
        const togglerEl = navbarEl?.querySelector('.main-navbar__toggler');

        if (navbarEl === null || collapseEl === null || togglerEl === null) {
            return;
        }

        collapseEl.addEventListener('show.bs.collapse', () => {
            navbarEl.classList.add('main-navbar--open');
            togglerEl.setAttribute('aria-label', 'Sluit navigatie');
        });

        collapseEl.addEventListener('hidden.bs.collapse', () => {
            navbarEl.classList.remove('main-navbar--open');
            togglerEl.setAttribute('aria-label', 'Open navigatie');
        });
    }

    initStickyNavbar() {
        const navbar = document.getElementById('main-navbar');

        const header = document.querySelector('header');

        if (navbar === null || header == null) {
            return false;
        }

        const scrolled = navbar.offsetHeight;

        const sticky = header.offsetHeight;

        window.addEventListener('scroll', () => {
            if (window.pageYOffset >= scrolled) {
                navbar.classList.add('scrolled');
            } else {
                navbar.classList.remove('scrolled');
            }

            if (window.pageYOffset >= sticky) {
                navbar.classList.add('sticky');
            } else {
                navbar.classList.remove('sticky');
            }
        });
    }

    partnerSlider() {
        document.querySelectorAll('.partners__carousel').forEach(element => {
            new Swiper('#' + element.getAttribute('id'), {
                autoplay: true,
                loop: true,
                /*breakpoints: {
                    0: {
                        slidesPerView: 2,
                        spaceBetween: 50
                    },
                    576: {
                        slidesPerView: 3,
                        spaceBetween: 50
                    },
                    768: {
                        slidesPerView: 4,
                        spaceBetween: 50
                    },
                    992: {
                        slidesPerView: 5,
                        spaceBetween: 50
                    },
                    1200: {
                        slidesPerView: 'auto',
                        spaceBetween: 50
                    }
                },*/
                centerInsufficientSlides: true,
                slidesPerView: 'auto',
                spaceBetween: 50,
                slidesPerGroup: 1
            });
        });
    }

    /**
     * Honey pot protection for forms
     */
    honeyForms() {
        document.querySelectorAll('.form-honey').forEach(form => {
            setTimeout(() => {
                let buttonSubmit = form.querySelector('button[type="submit"]');

                if (buttonSubmit) {
                    // Restore original button text
                    buttonSubmit.innerHTML = buttonSubmit.getAttribute('data-text');

                    // Enable the submit button
                    buttonSubmit.disabled = false;
                }

                let coffeeCup = form.querySelector('input[name="coffee_cup"]');

                if (coffeeCup) {
                    // Fill the coffee cup
                    coffeeCup.value = 'filled';
                }
            }, 5000);
        });
    }

    /**
     * Process asynchronous forms
     */
    asyncForms() {
        let gRecaptchaWidgets = [];

        document.querySelectorAll('.g-recaptcha-widget').forEach(recaptcha => {
            let widgetId = grecaptcha.render(recaptcha.id, {
                'sitekey' : config.recaptcha_site_key
            });

            gRecaptchaWidgets.push(widgetId);
        });

        /**
         * Refresh reCAPTCHA
         */
        let refreshRecaptcha = () => {
            // Check if reCAPTCHA is loaded
            if (typeof grecaptcha === 'undefined') {
                return;
            }

            // Refresh all recaptcha widget instances
            gRecaptchaWidgets.forEach(widgetId => {
                grecaptcha.reset(widgetId);
            });
        }

        setInterval(function() {
            refreshRecaptcha();
        }, 2 * 60 * 1000);

        document.querySelectorAll('.form-async').forEach(form => {
            form.addEventListener('submit', (e) => {
                e.preventDefault();

                // Serialize all form data
                let formData = new FormData(form);

                // Fetch container for the form messages
                let formMessages = form.querySelector('.form-messages');

                // Clear the form errors
                form.querySelectorAll('[data-error]').forEach(errorMessage => {
                    // Clear error message
                    errorMessage.innerHTML = '';

                    // Remove multiple status class
                    errorMessage.classList.remove('multiple');
                });

                // Clear the form messages
                formMessages.replaceChildren();

                Helper.post(form.getAttribute('action'), formData).then(response => {
                    if (response.redirect_url) {
                        // Redirect to the given URL
                        window.location.href = response.redirect_url;
                    }
                    else {
                        // Reset form
                        form.reset();

                        // Refresh reCAPTCHA
                        refreshRecaptcha();

                        formMessages.innerHTML = '<div class="alert alert--' + response.message.type + '"><span>' + response.message.text + '</span></div>';
                    }
                })
                .catch(error => {
                    let statusCode = error.statusCode;

                    switch (statusCode) {
                        case 422:
                            // Set error messages
                            Object.entries(error.response.errors).forEach(([key, errors]) => {
                                // Find the target element with data-error attribute
                                const targetElement = form.querySelector('[data-error="' + key + '"]');

                                if (targetElement === null) {
                                    return;
                                }

                                if (errors.length > 1) {
                                    // Mark container as multiple errors
                                    targetElement.classList.add('multiple');
                                }

                                errors.forEach(function (error) {
                                    // Create a new <span> element
                                    const errorSpan = document.createElement('span');

                                    // Set the text content of the <span>
                                    errorSpan.textContent = error;

                                    // Append the <span> as a child of the target element
                                    targetElement.appendChild(errorSpan);
                                });
                            });
                            break;

                        default:
                            // Show notification
                            alert('Er is iets misgegaan.');
                    }

                    // Refresh reCAPTCHA
                    refreshRecaptcha();

                    // Reject the promise
                    return Promise.reject(error.statusText);
                });
            });
        });
    }

    cookies() {
        let form = document.getElementById('form-cookies');

        if (form === null) {
            return false;
        }

        // Show the cookie form
        form.classList.remove('fade');

        // Add cookie selection state
        document.body.classList.add('cookie-selection');

        let options = form.querySelector('.cookies-banner__options');

        let textChecked   = 'Alle cookies accepteren';
        let textUnchecked = 'Geselecteerde cookies accepteren'

        let buttonSubmit = form.querySelector('button[type="submit"]');

        let isAllCookiesChecked = function () {
            let checked = true;

            options.querySelectorAll('.form-check-input').forEach(switchElement => {
                if (switchElement.checked === false) {
                    checked = false;
                }
            });

            return checked;
        }

        options.querySelectorAll('.form-check-input').forEach(input => {
            // Bind the change event listener to the form check input
            input.addEventListener('change', function () {
                buttonSubmit.innerText = isAllCookiesChecked() ? textChecked : textUnchecked;
            });

            // Manually create on on-change event
            let event = new Event('change');

            // Manually dispatch event
            input.dispatchEvent(event);
        });

        const collapseCookies = document.getElementById('collapse-cookies');

        collapseCookies.addEventListener('show.bs.collapse', () => {
            collapseCookies.querySelectorAll('.form-check-input:not(#cookies-functional)').forEach(input => {
                input.checked = false;
            });

            buttonSubmit.innerText = textUnchecked;
        })

        form.addEventListener('submit', function(e) {
            e.preventDefault();

            let formData = new FormData(this);

            if (e.submitter) {
                // Manually add button name and value
                formData.append(e.submitter.name, e.submitter.value);
            }

            Helper.post(this.action, formData).then(() => {
                // Remove cookie selection state
                document.body.classList.remove('cookie-selection');

                // Fade out the form
                form.classList.add('fade');

                setTimeout(function () {
                    // Reload page
                    location.reload();
                }, 1000);
            })
            .catch(error => {
                // Reject the promise
                return Promise.reject(error.statusText);
            });
        });
    }

    stepsScroller() {
        const scrollers = document.querySelectorAll('.steps__list--scroll');

        if (scrollers.length === 0) {
            return;
        }

        const setScrollerWidth = () => {
            const viewportWidth = document.documentElement.clientWidth;

            scrollers.forEach(scroller => {
                const { left } = scroller.getBoundingClientRect();

                const width = Math.max(0, viewportWidth - left);

                scroller.style.width = `${width}px`;
            });
        };

        const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

        const getScrollStep = scroller => {
            const firstItem = scroller.querySelector('.steps__item');

            if (firstItem === null) {
                return scroller.clientWidth;
            }

            const styles = window.getComputedStyle(scroller);
            const gap = Number.parseFloat(styles.columnGap || styles.gap || '0');

            return firstItem.getBoundingClientRect().width + gap;
        };

        const getWheelDelta = (event, scroller) => {
            const rawDelta = Math.abs(event.deltaX) > Math.abs(event.deltaY)
                ? event.deltaX
                : event.deltaY;

            if (rawDelta === 0) {
                return 0;
            }

            switch (event.deltaMode) {
                case WheelEvent.DOM_DELTA_LINE:
                    return rawDelta * 16;

                case WheelEvent.DOM_DELTA_PAGE:
                    return rawDelta * scroller.clientWidth;

                default:
                    return rawDelta;
            }
        };

        setScrollerWidth();

        window.addEventListener('load', setScrollerWidth);
        window.addEventListener('resize', setScrollerWidth);

        scrollers.forEach(scroller => {
            let isDragging = false;
            let startX = 0;
            let startScrollLeft = 0;
            let wheelScrollTimeout = null;
            const swipeButtons = scroller.parentElement?.querySelectorAll('.steps__swipe') ?? [];

            swipeButtons.forEach(button => {
                button.addEventListener('click', () => {
                    const maxScrollLeft = scroller.scrollWidth - scroller.clientWidth;

                    if (maxScrollLeft <= 0) {
                        return;
                    }

                    const nextScrollLeft = scroller.scrollLeft >= maxScrollLeft - 4
                        ? 0
                        : clamp(scroller.scrollLeft + getScrollStep(scroller), 0, maxScrollLeft);

                    scroller.scrollTo({
                        left: nextScrollLeft,
                        behavior: 'smooth'
                    });
                });
            });

            scroller.addEventListener('mousedown', e => {
                isDragging = true;
                startX = e.pageX;
                startScrollLeft = scroller.scrollLeft;

                scroller.classList.add('is-dragging');
            });

            window.addEventListener('mouseup', () => {
                isDragging = false;
                scroller.classList.remove('is-dragging');
            });

            scroller.addEventListener('mouseleave', () => {
                isDragging = false;
                scroller.classList.remove('is-dragging');
            });

            window.addEventListener('mousemove', e => {
                if (isDragging === false) {
                    return;
                }

                e.preventDefault();

                const distance = e.pageX - startX;

                scroller.scrollLeft = startScrollLeft - distance;
            });

            scroller.addEventListener('dragstart', e => {
                e.preventDefault();
            });

            scroller.addEventListener('wheel', e => {
                const canScrollHorizontally = scroller.scrollWidth > scroller.clientWidth;

                if (canScrollHorizontally === false) {
                    return;
                }

                const horizontalDelta = getWheelDelta(e, scroller);

                if (horizontalDelta === 0) {
                    return;
                }

                e.preventDefault();

                scroller.style.scrollSnapType = 'none';

                if (wheelScrollTimeout !== null) {
                    window.clearTimeout(wheelScrollTimeout);
                }

                const maxScrollLeft = scroller.scrollWidth - scroller.clientWidth;
                scroller.scrollLeft = clamp(scroller.scrollLeft + horizontalDelta, 0, maxScrollLeft);

                wheelScrollTimeout = window.setTimeout(() => {
                    scroller.style.scrollSnapType = '';
                }, 150);
            }, { passive: false });
        });
    }

    scrollIntoView() {
        document.querySelectorAll('a[href^="#"]').forEach(anchor => {
            anchor.addEventListener('click', function (e) {
                const targetId = this.getAttribute('href').slice(1); // remove the #

                const target = document.getElementById(targetId);

                if (target) {
                    e.preventDefault();

                    target.scrollIntoView({
                        behavior: 'smooth'
                    });
                }
            });
        });

        const buttonScroll = document.getElementById('scroll-down');

        if (buttonScroll) {
            buttonScroll.addEventListener('click', function (e) {
                e.preventDefault();

                let target = document.querySelector('section:first-of-type');

                if (target === null) {
                    target = document.querySelector('footer');
                }

                window.scrollTo({
                    top: target.getBoundingClientRect().top + window.scrollY,
                    behavior: 'smooth'
                });
            });
        }
    }
}

window.addEventListener('load', () => new App());
